import { render, staticRenderFns } from "./ServiceInfoIframe.vue?vue&type=template&id=99afef26&"
import script from "./ServiceInfoIframe.vue?vue&type=script&lang=ts&"
export * from "./ServiceInfoIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports